// Constantes de domínio do G17 (dados puros, sem dependências).
// Extraído de App.js sem alteração de conteúdo.

export const ADMIN_EMAILS = ["romano.rafael@outlook.com"];

export const NAV = [
  { id: "dashboard", icon: "⬡", label: "Dashboard" },
  { id: "rotina",    icon: "◷", label: "Rotina" },
  { id: "ciclo",     icon: "⟳", label: "Ciclo de Estudos" },
  { id: "calendario", icon: "▦", label: "Calendário" },
  { id: "edital",     icon: "☰", label: "Edital Verticalizado" },
  { id: "resumos",    icon: "▤", label: "Meus Resumos" },
  { id: "flashcards", icon: "▣", label: "Flashcards" },
  { id: "simulados", icon: "◈", label: "Simulados" },
  { id: "taf",       icon: "⚑", label: "TAF" },
  // { id: "questoes",  icon: "✦", label: "Questões" }, // desativado temporariamente
  { id: "comunidade", icon: "❖", label: "Comunidade" },
  { id: "perfil",     icon: "◉", label: "Perfil" },
];

export const BASE_CONCURSOS = [
  { id: "pf",    label: "PF",    full: "Polícia Federal",              color: "#fbbf24" },
  { id: "prf",   label: "PRF",   full: "Polícia Rodoviária Federal",   color: "#ef4444" },
  { id: "pcdf",  label: "PCDF",  full: "Polícia Civil do DF",          color: "#60a5fa" },
  { id: "pcrj",  label: "PCRJ",  full: "Polícia Civil do RJ",          color: "#f472b6" },
  { id: "pcsp",  label: "PCSP",  full: "Polícia Civil de SP",          color: "#fb923c" },
  { id: "pcmg",  label: "PCMG",  full: "Polícia Civil de MG",          color: "#a78bfa" },
  { id: "pcgo",  label: "PCGO",  full: "Polícia Civil de GO",          color: "#34d399" },
  { id: "pmerj", label: "PMERJ", full: "PM do Estado do RJ",           color: "#06b6d4" },
  { id: "pmesp", label: "PMESP", full: "PM do Estado de SP",           color: "#e879f9" },
  { id: "pmdf",  label: "PMDF",  full: "PM do Distrito Federal",       color: "#4ade80" },
  { id: "pcba",  label: "PCBA",  full: "Polícia Civil da BA",          color: "#facc15" },
  { id: "pcpe",  label: "PCPE",  full: "Polícia Civil de PE",          color: "#38bdf8" },
];

export const FRASES_DO_DIA = [
  "A disciplina é a ponte entre metas e conquistas.",
  "Cada hora de estudo hoje é um passo mais perto da aprovação.",
  "O concurso não vai esperar. Mas o resultado vai valer cada sacrifício.",
  "Não existe atalho para a aprovação — apenas o caminho que você percorre todos os dias.",
  "Quem estuda consistentemente não precisa de sorte.",
  "A aprovação é a soma de todos os dias que você escolheu estudar em vez de desistir.",
  "Você não precisa ser o melhor. Precisa ser melhor que o edital.",
  "Um dia de estudo ruim ainda é melhor que um dia sem estudo nenhum.",
  "Foco, força e fé no processo. O resultado vem.",
  "Enquanto você dorme, alguém estuda. Mas você já está aqui — isso já é diferença.",
  "O concurseiro que chega na prova tranquilo é o que estudou quando não estava com vontade.",
  "Resiliência: estudar no cansaço, na dúvida, na saudade. E mesmo assim, avançar.",
  "Cada questão errada hoje é uma questão que você vai acertar na prova.",
  "Aprovação não é destino de sortudo — é destino de quem persiste.",
  "A rotina que parece monótona hoje vai te colocar numa farda amanhã.",
  "Você está construindo algo sólido. Tijolo por tijolo, dia por dia.",
  "Nenhum esforço de estudo é desperdiçado — tudo fica registrado na sua mente.",
  "A diferença entre o candidato aprovado e o reprovado muitas vezes é uma semana de estudo a mais.",
  "Não compare seu progresso com o dos outros. Compare com quem você era ontem.",
  "Confie no processo. O G17 está do seu lado.",
  "Gabarito não mente: quem estuda, passa.",
  "O policial que você quer ser amanhã começa com o estudante que você é hoje.",
  "Cada simulado é um treinamento. A prova real é o campeonato.",
  "Estude como se dependesse só de você. Ore como se dependesse de algo maior.",
  "Menos reclamação, mais revisão.",
  "Você foi feito para isso. Continue.",
  "A farda não se conquista com talento — se conquista com dedicação diária.",
  "Seja o candidato que a banca teme: aquele que não desiste.",
  "Hoje é mais um dia de investimento no seu futuro de aprovado.",
  "Não espere motivação para começar. Comece para encontrar motivação.",
];

export const BADGES = [
  { id:"primeiros_passos", icon:"🎯", label:"Primeiros Passos",  desc:"Estudou 1h no total",              cat:"estudo"    },
  { id:"dedicado",         icon:"📚", label:"Dedicado",           desc:"Estudou 10h no total",             cat:"estudo"    },
  { id:"guerreiro",        icon:"⚔️", label:"Guerreiro",          desc:"Estudou 50h no total",             cat:"estudo"    },
  { id:"veterano",         icon:"🏅", label:"Veterano",           desc:"Estudou 100h no total",            cat:"estudo"    },
  { id:"elite",            icon:"👑", label:"Elite",              desc:"Estudou 500h no total",            cat:"estudo"    },
  { id:"simulado_1",       icon:"📝", label:"Primeiro Simulado",  desc:"Completou 1 simulado",             cat:"simulado"  },
  { id:"simulado_5",       icon:"🧠", label:"Mentalmente Forte",  desc:"Completou 5 simulados",            cat:"simulado"  },
  { id:"simulado_10",      icon:"🔥", label:"Em Chamas",          desc:"Completou 10 simulados",           cat:"simulado"  },

  { id:"streak_3",         icon:"📅", label:"3 Dias Seguidos",    desc:"Estudou 3 dias consecutivos",      cat:"streak"    },
  { id:"streak_7",         icon:"🗓️", label:"Semana Completa",   desc:"Estudou 7 dias consecutivos",      cat:"streak"    },
  { id:"streak_30",        icon:"🔱", label:"Disciplina Total",   desc:"Estudou 30 dias consecutivos",     cat:"streak"    },
  { id:"aproveitamento_70",icon:"🎯", label:"Atirador",           desc:"70%+ de acertos num simulado",     cat:"desempenho"},
  { id:"aproveitamento_90",icon:"🏆", label:"Sniper",             desc:"90%+ de acertos num simulado",     cat:"desempenho"},
  { id:"resumo_1",         icon:"📝", label:"Primeiro Resumo",    desc:"Escreveu 1 resumo",                cat:"resumos"   },
  { id:"resumo_10",        icon:"✍️", label:"Escriba",            desc:"Escreveu 10 resumos",              cat:"resumos"   },
  { id:"resumo_50",        icon:"📚", label:"Biblioteca Viva",    desc:"Escreveu 50 resumos",              cat:"resumos"   },
  { id:"card_1",           icon:"🃏", label:"Primeiro Cartão",    desc:"Criou 1 flashcard",                cat:"flashcards"},
  { id:"card_100",         icon:"🗂️", label:"Baralho Cheio",      desc:"Criou 100 flashcards",             cat:"flashcards"},
  { id:"card_500",         icon:"🧩", label:"Mestre dos Cartões", desc:"Criou 500 flashcards",             cat:"flashcards"},
  { id:"rev_1",            icon:"🔁", label:"Primeira Revisão",   desc:"Revisou 1 flashcard",              cat:"flashcards"},
  { id:"rev_100",          icon:"🧠", label:"Revisor Dedicado",   desc:"Revisou 100 flashcards diferentes",cat:"flashcards"},
  { id:"rev_500",          icon:"🐘", label:"Memória de Elefante",desc:"Revisou 500 flashcards diferentes",cat:"flashcards"},
];

export const DAYS_SHORT = ["D","S","T","Q","Q","S","S"];
export const DAYS_FULL  = ["Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado"];

// ── CONTEST SUBJECTS — baseado nos últimos editais/provas ───────────────────
// Peso = número de questões na última prova objetiva (PF: prova de 2025 — Penal e Processual Penal somam 6, divididos 3 + 3)
export const CONTEST_SUBJECTS = {
  // PRF — pesos informados pelo usuário
  prf: [
    { name:"Legislação de Trânsito",              weight:30 },
    { name:"Português",                            weight:18 },
    { name:"Informática",                          weight:7  },
    { name:"Raciocínio Lógico-Matemático",         weight:6  },
    { name:"Direito Constitucional",               weight:7  },
    { name:"Direito Administrativo",               weight:5  },
    { name:"Direito Penal",                        weight:5  },
    { name:"Direito Processual Penal",             weight:5  },
    { name:"Direitos Humanos",                     weight:5  },
    { name:"Legislação Especial Extravagante",     weight:6  },
    { name:"Ética e Cidadania",                   weight:6  },
    { name:"Inglês ou Espanhol",                  weight:8  },
    { name:"Física",                               weight:5  },
    { name:"Geopolítica",                          weight:5  },
    { name:"Legislação da PRF",                   weight:2  },
  ],
  // PF — Agente de Polícia Federal
  "pf-agente": [
    { name:"Informática",                          weight:36 },
    { name:"Contabilidade",                        weight:24 },
    { name:"Português",                            weight:10 },
    { name:"Raciocínio Lógico Matemático",         weight:8  },
    { name:"Estatística",                          weight:8  },
    { name:"Direito Constitucional",               weight:6  },
    { name:"Direito Administrativo",               weight:6  },
    { name:"Direitos Humanos",                     weight:6  },
    { name:"Direito Penal",                        weight:3  },
    { name:"Direito Processual Penal",             weight:3  },
    { name:"Legislação Especial Extravagante",     weight:10 },
  ],
  // PF — Escrivão de Polícia Federal
  "pf-escrivao": [
    { name:"Informática",                          weight:36 },
    { name:"Contabilidade",                        weight:14 },
    { name:"Português",                            weight:10 },
    { name:"Arquivologia",                         weight:10 },
    { name:"Raciocínio Lógico-Matemático",         weight:8  },
    { name:"Estatística",                          weight:8  },
    { name:"Direito Constitucional",               weight:6  },
    { name:"Direito Administrativo",               weight:6  },
    { name:"Direitos Humanos",                     weight:6  },
    { name:"Direito Penal",                        weight:3  },
    { name:"Direito Processual Penal",             weight:3  },
    { name:"Legislação Especial Extravagante",     weight:10 },
  ],
  // PF — Papiloscopista da Polícia Federal
  "pf-papiloscopista": [
    { name:"Informática",                          weight:36 },
    { name:"Português",                            weight:10 },
    { name:"Legislação Especial Extravagante",     weight:10 },
    { name:"Raciocínio Lógico Matemático",         weight:8  },
    { name:"Estatística",                          weight:8  },
    { name:"Biologia",                             weight:8  },
    { name:"Física",                               weight:8  },
    { name:"Química",                              weight:8  },
    { name:"Direito Constitucional",               weight:6  },
    { name:"Direito Administrativo",               weight:6  },
    { name:"Direitos Humanos",                     weight:6  },
    { name:"Direito Penal",                        weight:3  },
    { name:"Direito Processual Penal",             weight:3  },
  ],
  // PF — Delegado de Polícia Federal
  "pf-delegado": [
    { name:"Direito Processual Penal",             weight:23 },
    { name:"Direito Penal",                        weight:22 },
    { name:"Direito Constitucional",               weight:12 },
    { name:"Direito Administrativo",               weight:12 },
    { name:"Direitos Humanos",                     weight:10 },
    { name:"Direito Ambiental",                    weight:8  },
    { name:"Direito Internacional",                weight:6  },
    { name:"Direito Previdenciário",               weight:6  },
    { name:"Direito Tributário",                   weight:6  },
    { name:"Direito Civil",                        weight:4  },
    { name:"Direito Processual Civil",             weight:4  },
    { name:"Criminologia",                         weight:4  },
    { name:"Direito Empresarial",                  weight:3  },
  ],
  // PF — Agente Administrativo [PF]
  "pf-administrativo": [
    { name:"Português",                            weight:24 },
    { name:"Direito Administrativo",               weight:18 },
    { name:"Gestão de Contratos e Recursos Materiais", weight:14 },
    { name:"Noções de Governança Pública",         weight:12 },
    { name:"Direito Constitucional",               weight:10 },
    { name:"Informática",                          weight:10 },
    { name:"Raciocínio Lógico-Matemático",         weight:10 },
    { name:"Gestão de Pessoas",                    weight:10 },
    { name:"Legislação da PF",                     weight:6  },
    { name:"Ética no Serviço Público",             weight:6  },
  ],
  // PRF — Agente (mantém compatibilidade)
  pf: [
    { name:"Informática",                          weight:36 },
    { name:"Contabilidade",                        weight:24 },
    { name:"Português",                            weight:10 },
    { name:"Raciocínio Lógico Matemático",         weight:8  },
    { name:"Estatística",                          weight:8  },
    { name:"Direito Constitucional",               weight:6  },
    { name:"Direito Administrativo",               weight:6  },
    { name:"Direitos Humanos",                     weight:6  },
    { name:"Direito Penal",                        weight:3  },
    { name:"Direito Processual Penal",             weight:3  },
    { name:"Legislação Especial Extravagante",     weight:10 },
  ],
  // PRF — Agente Administrativo
  "prf-administrativo": [
    { name:"Português",                            weight:19 },
    { name:"Direito Constitucional",               weight:24 },
    { name:"Raciocínio Lógico-Matemático",         weight:9  },
    { name:"Direito Administrativo",               weight:6  },
    { name:"Informática",                          weight:9  },
    { name:"Administração",                        weight:9  },
    { name:"Legislação da PRF",                    weight:9  },
    { name:"Arquivologia",                         weight:9  },
    { name:"Ética e Cidadania",                    weight:6  },
  ],
  // PCDF 2021 — Agente (CEBRASPE) — 120q total
  // Bloco I (50q): Port.13, Ing.7, Inf.8, RLM.12, Conhec.DF.10
  // Bloco II (70q): D.Adm.10, D.Const.12, D.Penal.10, Proc.Penal.10, Dir.Humanos.7, Leg.Esp.8, Crim.8, Cont.5
  pcdf: [
    { name:"Português",                      weight:13 },
    { name:"Inglês / Espanhol",             weight:7  },
    { name:"Informática",                    weight:8  },
    { name:"Raciocínio Lógico",             weight:12 },
    { name:"Conhecimentos sobre o DF",       weight:10 },
    { name:"Direito Constitucional",         weight:12 },
    { name:"Direito Administrativo",         weight:10 },
    { name:"Direito Penal",                  weight:10 },
    { name:"Proc. Penal",                    weight:10 },
    { name:"Direitos Humanos",               weight:7  },
    { name:"Legislação Especial",            weight:8  },
    { name:"Criminologia",                   weight:8  },
    { name:"Contabilidade Pública",          weight:5  },
  ],
  // PCDF 2026 — Delegado (Cebraspe). O edital não informa itens por matéria: pesos são ESTIMADOS (120 itens).
  "pcdf-delegado": [
    { name:"Direito Penal",                  weight:18 },
    { name:"Direito Processual Penal",       weight:16 },
    { name:"Direito Constitucional",         weight:14 },
    { name:"Direito Administrativo",         weight:14 },
    { name:"Direito Civil",                  weight:10 },
    { name:"Direito Tributário",             weight:8  },
    { name:"Medicina Legal",                 weight:8  },
    { name:"Direito Empresarial",            weight:8  },
    { name:"Direito Ambiental",              weight:6  },
    { name:"Conhecimentos do Distrito Federal", weight:6 },
  ],
  // PCDF 2020 — Agente (Cebraspe). Bloco I = 50 itens, Bloco II = 70; divisão por matéria ESTIMADA (a partir da prova de 2021).
  "pcdf-agente": [
    { name:"Língua Portuguesa",              weight:13 },
    { name:"Inglês",                         weight:7  },
    { name:"Conhecimentos sobre o Distrito Federal", weight:10 },
    { name:"Legislação",                     weight:8  },
    { name:"Matemática e Raciocínio Lógico", weight:12 },
    { name:"Direito Constitucional",         weight:12 },
    { name:"Direito Administrativo",         weight:10 },
    { name:"Direito Penal",                  weight:10 },
    { name:"Direito Processual Penal",       weight:10 },
    { name:"Direitos Humanos",               weight:7  },
    { name:"Informática",                    weight:8  },
    { name:"Estatística",                    weight:6  },
    { name:"Contabilidade",                  weight:7  },
  ],
  // Polícia Penal do Paraná 2024 (Instituto AOCP) — 75 questões: Gerais 25 (Port. 10, RLM 10, Inf. 5) e Específicos 50 (valem 1,5 ponto cada).
  // O edital não divide as 50 específicas por matéria: pesos dessas matérias são ESTIMADOS.
  pppr: [
    { name:"Língua Portuguesa",                    weight:10 },
    { name:"Raciocínio Lógico Matemático",         weight:10 },
    { name:"Informática",                          weight:5  },
    { name:"Legislação Extravagante",              weight:12 },
    { name:"Direito Penitenciário e Criminologia", weight:12 },
    { name:"Direito Penal",                        weight:10 },
    { name:"Direito Processual Penal",             weight:9  },
    { name:"Direito Administrativo",               weight:8  },
    { name:"Direito Constitucional",               weight:7  },
    { name:"Direitos Humanos",                     weight:7  },
  ],
  // PCMG 2022 — Investigador (IBFC) — 100q total
  // Port.15, RLM.10, Inf.8, D.Const.12, D.Adm.12, D.Penal.15, Proc.Penal.10, Leg.Est.10, Crim.8
  pcmg: [
    { name:"Português",                      weight:15 },
    { name:"Raciocínio Lógico",             weight:10 },
    { name:"Informática",                    weight:8  },
    { name:"Direito Constitucional",         weight:12 },
    { name:"Direito Administrativo",         weight:12 },
    { name:"Direito Penal",                  weight:15 },
    { name:"Proc. Penal",                    weight:10 },
    { name:"Legislação Estadual (MG)",       weight:10 },
    { name:"Criminologia",                   weight:8  },
  ],
  // PMDF 2022 — Soldado (CEBRASPE) — 120q total
  // Port.20, Inglês.5, Mat.20, Física.10, Química.10, Biologia.10, Hist/Geo.15, Inf.10, Leg.Tran.10, Leg.PM.10
  pmdf: [
    { name:"Português",                      weight:20 },
    { name:"Inglês / Espanhol",             weight:5  },
    { name:"Matemática / RLM",              weight:20 },
    { name:"Física",                         weight:10 },
    { name:"Química",                        weight:10 },
    { name:"Biologia / Primeiros Socorros",  weight:10 },
    { name:"História e Geografia",           weight:15 },
    { name:"Informática",                    weight:10 },
    { name:"Legislação de Trânsito",         weight:10 },
    { name:"Legislação Específica PM",       weight:10 },
  ],
  // PMMG 2022 — Soldado (FUMARC) — 100q total
  // Port.20, RLM.15, D.Const.15, D.Adm.10, D.Penal.12, Leg.Est.13, Inf.8, Conhec.Ger.7
  pmmg: [
    { name:"Português",                      weight:20 },
    { name:"Raciocínio Lógico e Matemática", weight:15 },
    { name:"Direito Constitucional",         weight:15 },
    { name:"Direito Administrativo",         weight:10 },
    { name:"Direito Penal e Proc. Penal",    weight:12 },
    { name:"Legislação Estadual (MG)",       weight:13 },
    { name:"Informática",                    weight:8  },
    { name:"Conhecimentos Gerais",           weight:7  },
  ],
  // BM (CBMDF 2022 — CEBRASPE) — 120q total
  // Port.20, Inglês.5, Mat.20, Física.10, Química.10, Biologia.10, Hist/Geo.15, Inf.10, Leg.BM.20
  bm: [
    { name:"Português",                      weight:20 },
    { name:"Inglês / Espanhol",             weight:5  },
    { name:"Matemática / RLM",              weight:20 },
    { name:"Física",                         weight:10 },
    { name:"Química",                        weight:10 },
    { name:"Biologia / Primeiros Socorros",  weight:10 },
    { name:"História e Geografia",           weight:15 },
    { name:"Informática",                    weight:10 },
    { name:"Legislação Específica BM",       weight:20 },
  ],
  // Enem — 4 áreas de 45 questões + redação (pesos para dividir o tempo; ajuste conforme seu nível)
  enem: [
    { name:"Linguagens, Códigos e suas Tecnologias", weight:45 },
    { name:"Matemática e suas Tecnologias",          weight:45 },
    { name:"Ciências da Natureza e suas Tecnologias", weight:45 },
    { name:"Ciências Humanas e suas Tecnologias",    weight:45 },
    { name:"Redação",                                 weight:30 },
  ],
  outros: [],
};

export const SUBJECT_COLORS = [
  "#34d399","#60a5fa","#f472b6","#fb923c","#a78bfa",
  "#fbbf24","#22d3ee","#f87171","#4ade80","#e879f9",
  "#38bdf8","#facc15","#fb7185","#86efac",
];

export const CONTEST_LIST = [
  { id:"pf",    label:"PF",    full:"Polícia Federal",            color:"#60a5fa", icon:"🛡️" },
  { id:"prf",   label:"PRF",   full:"Polícia Rodoviária Federal", color:"#fbbf24", icon:"🚔" },
  { id:"pcdf",  label:"PCDF",  full:"Polícia Civil do DF",        color:"#f87171", icon:"🔍" },
  { id:"pcmg",  label:"PCMG",  full:"Polícia Civil MG",           color:"#a78bfa", icon:"🔎" },
  { id:"pmdf",  label:"PMDF",  full:"Polícia Militar do DF",      color:"#34d399", icon:"👮" },
  { id:"pmmg",  label:"PMMG",  full:"Polícia Militar MG",         color:"#fb923c", icon:"🎖️" },
  { id:"enem",  label:"Enem",  full:"Exame Nacional do Ensino Médio", color:"#22d3ee", icon:"🎓" },
  { id:"pppr",  label:"PPPR",  full:"Polícia Penal do Paraná",   color:"#94a3b8", icon:"🔒" },
  { id:"bm",    label:"BM",    full:"Bombeiro Militar",           color:"#ef4444", icon:"🔥" },
  { id:"outros",label:"Outros",full:"Outros concursos",           color:"#94a3b8", icon:"📋" },
];

// Brasões das instituições (public/emblems). Guardados no próprio site — sem
// pedir nada a sites de terceiros. Concursos sem brasão usam o ícone da lista.
export const CONTEST_EMBLEMS = { pf:1, prf:1, pcdf:1, pcmg:1, pmdf:1, pmmg:1, pppr:1, enem:"svg" };

// Acha o concurso da lista a partir do valor salvo em target_contest. Aceita o id
// ("prf") e também texto digitado à mão ("PRF", "👮 PRF"), para esses usuários
// também aparecerem com o brasão em vez do emoji.
export function findContest(raw) {
  if (!raw) return undefined;
  const v = String(raw).trim();
  const byId = CONTEST_LIST.find(x => x.id === v);
  if (byId) return byId;
  const norm = x => String(x).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
  const si = v.indexOf(" ");
  const name = norm(si > 0 && !/[a-zA-Z0-9]/.test(v.slice(0, si)) ? v.slice(si + 1) : v);
  return CONTEST_LIST.find(x => x.id !== "outros" && (norm(x.label) === name || norm(x.full) === name));
}

export const STAR_LEVELS = [
  { stars:0, label:"Zero estrelas",   desc:"Ainda não iniciei os estudos da matéria. Ou se já a estudei no passado, não me lembro de mais nada." },
  { stars:1, label:"Uma estrela",     desc:"Iniciante: Iniciei recentemente o estudo da matéria. Ou se já vi no passado, me lembro de poucas coisas." },
  { stars:2, label:"Duas estrelas",   desc:"Iniciante/Intermediário: Já percorri metade do caminho ou mais, mas ainda me considero iniciante." },
  { stars:3, label:"Três estrelas",   desc:"Intermediário: Já estudei a maior parte da matéria, meu nível está ok, ou já finalizei a matéria e estou com um nível razoável." },
  { stars:4, label:"Quatro estrelas", desc:"Intermediário/Avançado: Já estudei quase toda a matéria, ou já a finalizei, e acerto boa parte das questões que faço. Estou em um bom nível!" },
  { stars:5, label:"Cinco estrelas",  desc:"Avançado: Já vi toda a matéria, tenho um excelente nível. Costumo acertar todas ou quase todas as questões que faço." },
];

// ── TEMPOS DE PROVA POR CONCURSO (dados oficiais dos últimos editais) ─────────
export const EXAM_TIMES = {
  pf:  { label:"Polícia Federal", horas:4.5, questoes:120, obs:"Objetiva — CEBRASPE" },
  prf: { label:"PRF",             horas:4.5, questoes:120, obs:"Objetiva — CEBRASPE" },
};

export const DATE_RANGES = [
  { id:"today",    label:"Hoje" },
  { id:"yesterday",label:"Ontem" },
  { id:"7days",    label:"Últimos 7 dias" },
  { id:"15days",   label:"Últimos 15 dias" },
  { id:"month",    label:"Este mês" },
  { id:"alltime",  label:"Desde o início" },
];

export const CAL_SUBJECTS = [
  "Língua Portuguesa", "Raciocínio Lógico", "Informática", "Física",
  "Ética e Cidadania", "Geopolítica", "Língua Estrangeira",
  "Legislação de Trânsito", "Direito Administrativo", "Direito Constitucional",
  "Direito Penal", "Direito Processual Penal", "Legislação Especial",
  "Direitos Humanos", "Redação", "Simulado",
];
// Nomes do Ciclo que equivalem a linhas já existentes no calendário
export const CAL_ALIASES = {
  "Português": "Língua Portuguesa", "Raciocínio Lógico-Matemático": "Raciocínio Lógico", "Raciocínio Lógico Matemático": "Raciocínio Lógico",
  "Legislação Especial Extravagante": "Legislação Especial", "Inglês ou Espanhol": "Língua Estrangeira", "Inglês": "Língua Estrangeira", "Espanhol": "Língua Estrangeira",
};

export const CAL_MONTHS = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
export const CAL_WD = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];
export const CAL_MIN = { y: 2026, m: 0 };           // primeiro mês do calendário (janeiro/2026): não dá para voltar antes

// Dados importados da planilha (jan–set/2026), em minutos.
export const CAL_SEED = {
  days: {
    "2026-02-02": {"Raciocínio Lógico": 120, "Legislação de Trânsito": 120, "Direito Administrativo": 40},
    "2026-02-03": {"Direito Administrativo": 55, "Direito Constitucional": 15},
    "2026-02-04": {"Direito Administrativo": 30, "Direito Constitucional": 120, "Direito Penal": 90},
    "2026-02-05": {"Legislação de Trânsito": 180},
    "2026-02-06": {"Língua Portuguesa": 105, "Informática": 120, "Legislação de Trânsito": 40},
    "2026-02-07": {"Língua Portuguesa": 130, "Informática": 60},
    "2026-02-21": {"Legislação de Trânsito": 120},
    "2026-02-22": {"Legislação de Trânsito": 80},
    "2026-02-23": {"Direito Administrativo": 60, "Direito Constitucional": 40, "Direito Penal": 40},
    "2026-02-24": {"Legislação de Trânsito": 100, "Direito Constitucional": 150, "Direito Penal": 115},
    "2026-02-25": {"Língua Portuguesa": 120, "Legislação de Trânsito": 75},
    "2026-03-03": {"Língua Portuguesa": 120, "Legislação de Trânsito": 120},
    "2026-03-04": {"Língua Portuguesa": 20, "Raciocínio Lógico": 120, "Direito Administrativo": 120},
    "2026-03-09": {"Informática": 55},
    "2026-03-16": {"Raciocínio Lógico": 100, "Legislação de Trânsito": 120},
    "2026-03-18": {"Raciocínio Lógico": 80},
    "2026-03-23": {"Direito Constitucional": 205},
    "2026-06-05": {"Legislação de Trânsito": 40},
    "2026-07-16": {"Direito Penal": 120},
    "2026-07-23": {"Informática": 180, "Direito Constitucional": 202},
    "2026-07-24": {"Língua Portuguesa": 90, "Legislação de Trânsito": 60, "Direito Constitucional": 68, "Simulado": 75},
    "2026-07-25": {"Legislação de Trânsito": 230},
    "2026-07-26": {"Direito Constitucional": 48, "Direito Penal": 156},
    "2026-07-27": {"Direito Constitucional": 185},
    "2026-07-28": {"Direito Administrativo": 190},
    "2026-07-29": {"Raciocínio Lógico": 270},
    "2026-07-30": {"Raciocínio Lógico": 130},
    "2026-08-01": {"Redação": 45},
    "2026-09-24": {"Língua Portuguesa": 34},
  },
  bulk: {
    "2026-01": {"Língua Portuguesa": 360, "Raciocínio Lógico": 120, "Informática": 120, "Legislação de Trânsito": 780, "Direito Constitucional": 60},
  },
};

// Ao mudar o texto de forma relevante, suba LEGAL.version: todos verão o aviso de novo
// e o novo aceite fica registrado em profiles.terms_version / terms_accepted_at.
export const LEGAL = {
  version: 4,
  updated: "3 de novembro de 2026",
  controller: "Rafael Garcia Romano, pessoa física, responsável pelo G17",
  minAge: 18,
  email: "romano.rafael@outlook.com",
  site: "g17app.com.br",
};

// Colunas do perfil que o app lê (o e-mail não é legível por outros usuários).
export const PROFILE_COLS = "id, public_name, target_contest, avatar_url, accent_id, theme_mode, created_at, role, bio, banned, last_seen_at, theme_style, guide_version, terms_version, terms_accepted_at";

export const PRIVACY_DOC = {
  title: "Política de Privacidade",
  intro: `Esta política explica quais dados pessoais o G17 (${LEGAL.site}) coleta, para que eles são usados, com quem são compartilhados e como você exerce os seus direitos previstos na Lei Geral de Proteção de Dados (Lei nº 13.709/2018 — LGPD).`,
  sections: [
    { h: "1. Quem é o responsável pelos seus dados", p: [
      `O controlador dos dados é ${LEGAL.controller}, que também atua como encarregado pelo tratamento de dados pessoais (art. 41 da LGPD).`,
      `Contato para qualquer assunto de privacidade: ${LEGAL.email}.`,
    ]},
    { h: "2. Quais dados coletamos", p: [
      "Cadastro: nome público, e-mail, senha (guardada apenas de forma criptografada, nunca em texto) e concurso almejado.",
      "Perfil: foto, biografia, cargo/insígnia atribuído na comunidade e preferências de aparência.",
      "Estudos: rotinas, ciclos, tempos cronometrados, sessões de estudo (modo de estudo, assunto, duração e ajustes de tempo), simulados, projeções, questões, calendário e as anotações que você escreve nele.",
      "Edital verticalizado: os editais que você escolhe acompanhar, os assuntos marcados como concluídos, em andamento ou revisados e as autoavaliações (de \"muito ruim\" a \"muito bom\") que você dá a cada assunto.",
      "Comunidade: publicações, imagens enviadas, comentários e curtidas.",
      "Uso da plataforma: quais telas do G17 você abre, quando, por quanto tempo fica em cada uma e se usa celular ou computador. O conteúdo que você escreve não entra nesse registro. Guardamos esse histórico por até 90 dias.",
      "Dados técnicos: data de criação da conta, último acesso, avisos recebidos e registros de acesso (como endereço IP, data e hora) mantidos pelos provedores de hospedagem e autenticação.",
      "No seu navegador: o G17 guarda a sessão de login, as preferências de aparência e do aparelho (como pular a tela de carregamento) e cópias temporárias dos seus dados (armazenamento local). Não usamos cookies de publicidade nem ferramentas de rastreamento ou análise de terceiros.",
      "Controles na tela de bloqueio (opcional, desligado por padrão): mostram a matéria e o tempo do cronômetro no próprio aparelho, usando os recursos de mídia do navegador. Essas informações não são enviadas a ninguém.",
    ]},
    { h: "3. Para que usamos e com qual base legal", p: [
      "Prestar o serviço que você pediu ao criar a conta — salvar seus estudos, cronometrar, montar ciclos, mostrar estatísticas, ranking e comunidade (execução de contrato, art. 7º, V).",
      "Manter a plataforma segura: autenticar acessos, prevenir fraudes no ranking, moderar abusos e aplicar suspensões (legítimo interesse, art. 7º, IX, e exercício regular de direitos, art. 7º, VI).",
      "Entender como o G17 é usado (telas mais acessadas e tempo de uso) para corrigir problemas e decidir o que melhorar; só o administrador vê esses dados (legítimo interesse, art. 7º, IX).",
      "Enviar e-mails necessários à conta, como confirmação de cadastro e recuperação de senha (execução de contrato).",
      "Notificações do navegador e sons, somente se você permitir (consentimento, art. 7º, I), que pode ser retirado a qualquer momento nas configurações do navegador ou do Perfil.",
      "Cumprir obrigações legais e atender ordens de autoridades competentes (art. 7º, II).",
      "Não vendemos seus dados e não os usamos para publicidade.",
    ]},
    { h: "4. O que outros usuários veem", p: [
      "Usuários logados podem ver seu nome público, foto, biografia, concurso almejado, insígnias, horas estudadas (no ranking) e o que você publica, comenta ou curte na comunidade.",
      "Seu e-mail e seus dados de estudo detalhados (rotinas, ciclos, sessões, simulados, projeções, edital verticalizado e autoavaliações) não são exibidos a outros usuários.",
      "Não use seu nome completo ou foto se preferir não ser identificado — o nome público pode ser um apelido.",
    ]},
    { h: "5. Com quem compartilhamos", p: [
      "Somente com fornecedores necessários para o G17 funcionar, que tratam os dados conforme nossas instruções:",
      "Supabase — banco de dados, autenticação e armazenamento de imagens (servidores em São Paulo, Brasil).",
      "Vercel — hospedagem do site (Estados Unidos).",
      "Provedor de envio de e-mails transacionais (Supabase e/ou Resend — Estados Unidos).",
      "Autoridades públicas, quando houver obrigação legal ou ordem judicial.",
      "O link \"Apoie o G17\" leva a um site externo de doações, com política de privacidade própria.",
    ]},
    { h: "6. Transferência internacional", p: [
      "Alguns fornecedores ficam fora do Brasil (item 5). Essas transferências são necessárias para prestar o serviço e ocorrem com fornecedores que adotam garantias contratuais e de segurança compatíveis com a LGPD (art. 33).",
    ]},
    { h: "7. Por quanto tempo guardamos", p: [
      "Enquanto sua conta existir. Ao excluir a conta, seus dados e imagens são apagados imediatamente da base do G17.",
      "Cópias de segurança automáticas dos provedores podem levar até 30 dias para serem sobrescritas.",
      "Podemos manter o mínimo necessário para cumprir obrigação legal ou nos defender em processos, pelo prazo exigido em lei.",
    ]},
    { h: "8. Seus direitos", p: [
      "Pela LGPD (art. 18) você pode: confirmar se tratamos seus dados; acessá-los; corrigir dados incompletos ou desatualizados; pedir anonimização, bloqueio ou eliminação de dados desnecessários; portabilidade; eliminação dos dados; saber com quem compartilhamos; revogar consentimentos; e se opor a tratamentos irregulares.",
      "Direto no site: edite seus dados em Perfil; baixe uma cópia completa em Perfil → Conta → \"Baixar meus dados\"; exclua a conta em Perfil → Conta → \"Excluir conta\".",
      `Por e-mail: escreva para ${LEGAL.email}. Respondemos em até 15 dias.`,
      "Você também pode apresentar reclamação à Autoridade Nacional de Proteção de Dados (ANPD), em gov.br/anpd.",
    ]},
    { h: "9. Segurança", p: [
      "Conexão criptografada (HTTPS), senhas com criptografia, regras de acesso no banco que impedem um usuário de ler dados privados de outro, e acesso administrativo restrito.",
      "Ao criar ou trocar a senha, verificamos se ela já apareceu em vazamentos públicos usando o serviço Have I Been Pwned: apenas os 5 primeiros caracteres de um código (hash) da senha são consultados — a senha e seus dados pessoais nunca são enviados.",
      "Nenhum sistema é 100% seguro. Se ocorrer um incidente que possa trazer risco ou dano relevante, comunicaremos os usuários afetados e a ANPD (art. 48).",
    ]},
    { h: "10. Idade mínima", p: [
      `O G17 é destinado exclusivamente a maiores de ${LEGAL.minAge} anos. Ao criar a conta, você declara ter ${LEGAL.minAge} anos ou mais.`,
      "Não coletamos intencionalmente dados de crianças ou adolescentes. Se soubermos que uma conta pertence a menor de 18 anos, ela será excluída com seus dados.",
      `Pais ou responsáveis que identificarem uma conta de menor podem pedir a exclusão pelo e-mail ${LEGAL.email}.`,
    ]},
    { h: "11. Alterações desta política", p: [
      "Podemos atualizar esta política. A data da última versão fica no topo. Quando houver mudança relevante, avisaremos no site e pediremos um novo aceite.",
    ]},
  ],
};

export const TERMS_DOC = {
  title: "Termos de Uso",
  intro: `Estes termos regem o uso do G17 (${LEGAL.site}). Ao criar uma conta ou usar o site, você concorda com eles e com a Política de Privacidade.`,
  sections: [
    { h: "1. O serviço", p: [
      "O G17 é uma ferramenta gratuita de organização de estudos para concursos: rotina, ciclo de estudos, cronômetro, simulados, projeções, ranking e comunidade.",
      "O G17 não tem vínculo com bancas, órgãos públicos ou instituições policiais e não garante aprovação em concursos. Informações sobre editais e matérias são apenas referência: confira sempre o edital oficial.",
      "O edital verticalizado reproduz o conteúdo programático de editais publicados e o número de questões da última prova aplicada. Um edital novo pode mudar esse conteúdo; o G17 não se responsabiliza por diferenças entre a versão exibida e o edital vigente.",
    ]},
    { h: "2. Sua conta", p: [
      "Informe dados verdadeiros, mantenha sua senha em sigilo e não compartilhe a conta. Cada pessoa deve ter uma única conta.",
      "Você é responsável pelo que acontece na sua conta. Se suspeitar de uso indevido, troque a senha e avise pelo e-mail de contato.",
      `É preciso ter ${LEGAL.minAge} anos ou mais para criar conta e usar o G17. Contas de menores de idade serão excluídas.`,
    ]},
    { h: "3. Regras da comunidade", p: [
      "É proibido publicar ou enviar: conteúdo ilegal; ofensas, assédio, ameaças ou discurso de ódio; discriminação de qualquer tipo; conteúdo sexual ou violento; spam e propaganda não autorizada; dados pessoais de outras pessoas sem autorização; material protegido por direitos autorais sem permissão (incluindo apostilas e cursos pagos); e conteúdo enganoso.",
      "Você é o único responsável pelo que publica e garante ter os direitos sobre textos e imagens enviados. Ao publicar, autoriza o G17 a exibir esse conteúdo aos demais usuários enquanto ele estiver no ar.",
      "Você pode apagar suas publicações e comentários quando quiser.",
    ]},
    { h: "4. Ranking e uso justo", p: [
      "O ranking considera apenas o tempo registrado pelo cronômetro, incluindo o tempo extra depois que o bloco termina. Tempos inseridos manualmente e minutos acrescentados no ajuste ao finalizar uma sessão não contam; minutos retirados nesse ajuste são descontados também do ranking.",
      "Manipular o cronômetro, usar automações, explorar falhas ou tentar acessar dados de outros usuários é proibido.",
    ]},
    { h: "5. Moderação e suspensão", p: [
      "Podemos remover conteúdo que viole estes termos ou a lei e suspender ou encerrar contas em caso de violação, com ou sem aviso prévio, conforme a gravidade.",
      "Se você discordar de uma medida, escreva para o e-mail de contato.",
    ]},
    { h: "6. Propriedade intelectual", p: [
      "O nome, a marca, o visual e o código do G17 pertencem a Rafael Garcia Romano. Não é permitido copiar, revender ou explorar comercialmente o site sem autorização.",
    ]},
    { h: "7. Disponibilidade", p: [
      "Fazemos o possível para manter o G17 no ar e seus dados seguros, mas o serviço é oferecido como está, podendo ter interrupções, manutenções, falhas ou mudanças de funcionalidades. Recomendamos baixar periodicamente uma cópia dos seus dados (Perfil → Conta).",
      "O G17 pode ser encerrado; nesse caso, avisaremos com antecedência razoável para que você possa baixar seus dados.",
    ]},
    { h: "8. Responsabilidade", p: [
      "Na extensão permitida pela lei, o G17 não se responsabiliza por resultados em concursos, por decisões tomadas com base nas ferramentas do site, por conteúdo publicado por usuários ou por indisponibilidades fora do seu controle. Nada nestes termos limita direitos garantidos pelo Código de Defesa do Consumidor.",
    ]},
    { h: "9. Doações", p: [
      "O botão \"Apoie o G17\" leva a uma plataforma externa de doações voluntárias. Doar não dá vantagens no site, e a transação segue as regras da plataforma escolhida.",
    ]},
    { h: "10. Encerramento da conta", p: [
      "Você pode excluir sua conta a qualquer momento em Perfil → Conta → \"Excluir conta\". Seus dados serão apagados como descrito na Política de Privacidade.",
    ]},
    { h: "11. Alterações e lei aplicável", p: [
      "Podemos alterar estes termos. Mudanças relevantes serão avisadas no site e poderão exigir novo aceite.",
      "Aplica-se a lei brasileira. Fica eleito o foro do domicílio do usuário.",
      `Dúvidas: ${LEGAL.email}.`,
    ]},
  ],
};

// Ao mudar bastante o conteúdo, suba GUIDE_VERSION para todos verem de novo.
export const GUIDE_VERSION = 2;
